// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2vVjP","title":"AfterBackImages_title__2gJd-","images":"AfterBackImages_images__2azEa"};